
            const data = {"name":"arrow-right","data":{"width":"38","height":"8","viewBox":"0 0 38 8","data":"<path pid=\"0\" d=\"M37.107 4.354a.5.5 0 0 0 0-.708L33.925.464a.5.5 0 1 0-.707.708L36.046 4l-2.828 2.828a.5.5 0 0 0 .707.708l3.182-3.182ZM.327 4.5h36.426v-1H.326v1Z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                module.exports = data
                